import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, children }) => {
  const siteName = 'VMC';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = 'Discover trusted local businesses on VMC. Read verified customer reviews, compare quality signals, and list your company to build reputation.';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />

      {children}
    </Helmet>
  );
};

export default SEO;
